import { UtilityService } from '@eforall/common';
import { FilterOperator, GridColumn, buildColumn } from '@eforall/dashboard';
import { SpecialistFeedback } from '../specialist-feedback-view.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<SpecialistFeedback, unknown>[] = [
		buildColumn(util, 'Id', row => row.accSessionSpecialistSurveyResponseId, { header: 'accSessionSpecialistSurveyResponseId' }),
		buildColumn(util, 'Id', row => row.accId, { header: 'accId' }),
		buildColumn(util, 'Text', row => row.accName, { header: 'accName', width: 30 }),
		buildColumn(util, 'Id', row => row.entrepreneurPersonId, { header: 'entrepreneurPersonId' }),
		buildColumn(util, 'FullName', row => row.entrepreneurName, { header: 'Entrepreneur', width: 60 }),
		buildColumn(util, 'Id', row => row.eventId, { header: 'eventId' }),
		buildColumn(util, 'DateTime', row => util.date.fromUTC(row.eventStartUTC), { header: 'Session Date', width: 60 }),
		buildColumn(util, 'Id', row => row.specialistPersonId, { header: 'SpecialistPersonId' }),
		buildColumn(util, 'Text', row => row.specialistName, { header: 'Specialist Name', group: 'asc', hidden: true, }),
		buildColumn(util, 'Number', row => row.professionalismRating, { header: 'Professionalism Rating', headerTooltip: 'Professionalism: "TThe specialist was professional. (0..10)"', hidden: true }),
		buildColumn(util, 'Number', row => row.knowledgeRating, { header: 'Knowledge Rating', headerTooltip: 'Knowledge: "The specialist was knowledgeable about this topic. (0..10)"', hidden: true }),
		buildColumn(util, 'Number', row => row.effectivenessRating, { header: 'Effectiveness Rating', headerTooltip: 'Effectiveness: "The specialist effectively taught the topic. (0..10)"', hidden: true }),
		buildColumn(util, 'Text', row => row.feedback, { header: 'Feedback', filter: { operator: FilterOperator.IsNotNull } }),
	];


	return columns;

}